const AUTHORITY: any = {
  en: [
    {
      value: 'USER_CHILD_MANAGER',
      label: 'Management',
    },
    {
      value: 'USER_FACILITY_MANAGEMENT',
      label: 'Facility management',
    },
    {
      value: 'USER_BROWSE_FACILITY',
      label: 'Viewer',
    },
    {
      value: 'USER_REGISTRATION',
      label: 'Data registration',
    },
  ],
  ja: [
    {
      value: 'USER_CHILD_MANAGER',
      label: '管理（全拠点）',
    },
    {
      value: 'USER_FACILITY_MANAGEMENT',
      label: '管理（所属拠点）',
    },
    {
      value: 'USER_BROWSE_FACILITY',
      label: '閲覧',
    },
    {
      value: 'USER_REGISTRATION',
      label: 'データ登録',
    },
  ],
}

const CALCULATION_BASIS = (t: any) => [
  {
    value: '',
    label: '-',
  },
  {
    value: 'revenue',
    label: `${t('company.calculation_basis.revenue')}`,
  },
  {
    value: 'volume',
    label: `${t('company.calculation_basis.volume')}`,
  },
]

export const AUTHORITY_FACILITY_MANAGER: any = {
  en: [
    {
      value: 'USER_FACILITY_MANAGEMENT',
      label: 'Facility management',
    },
    {
      value: 'USER_BROWSE_FACILITY',
      label: 'Browse facility',
    },
    {
      value: 'USER_REGISTRATION',
      label: 'Data registration',
    },
  ],
  ja: [
    {
      value: 'USER_FACILITY_MANAGEMENT',
      label: '管理（所属拠点）',
    },
    {
      value: 'USER_BROWSE_FACILITY',
      label: '閲覧',
    },
    {
      value: 'USER_REGISTRATION',
      label: 'データ登録',
    },
  ],
}

const AUTHORITY_KEY: any = {
  en: {
    USER_PARENT: 'Parent user',
    USER_CHILD_MANAGER: 'Management',
    USER_FACILITY_MANAGEMENT: 'Facility management',
    USER_BROWSE_FACILITY: 'Viewer',
    USER_REGISTRATION: 'Data registration',
  },
  jp: {
    USER_PARENT: '親ユーザー',
    USER_CHILD_MANAGER: '管理（全拠点）',
    USER_FACILITY_MANAGEMENT: '管理（所属拠点）',
    USER_BROWSE_FACILITY: '閲覧',
    USER_REGISTRATION: 'データ登録',
  },
}

const STATUS: any = {
  en: [
    {
      value: 'INACTIVE',
      label: 'Inactive',
    },
    {
      value: 'ACTIVE',
      label: 'Active',
    },
  ],
  ja: [
    {
      value: 'INACTIVE',
      label: '無効',
    },
    {
      value: 'ACTIVE',
      label: '有効',
    },
  ],
}

const getRoleOptions = (): IRoleOptions => ({
  en: [
    {
      value: 'USER_CHILD_MANAGER',
      label: 'Management',
    },
    {
      value: 'USER_FACILITY_MANAGEMENT',
      label: 'Facility management',
    },
    {
      value: 'USER_BROWSE_FACILITY',
      label: 'Browse facility',
    },
    {
      value: 'USER_REGISTRATION',
      label: 'Data registration',
    },
  ],
  ja: [
    {
      value: 'USER_CHILD_MANAGER',
      label: '管理（全拠点）',
    },
    {
      value: 'USER_FACILITY_MANAGEMENT',
      label: '管理（所属拠点）',
    },
    {
      value: 'USER_BROWSE_FACILITY',
      label: '閲覧',
    },
    {
      value: 'USER_REGISTRATION',
      label: 'データ登録',
    },
  ],
})

const BRANCH_STATUS_KEY = {
  public: 'PUBLIC',
  private: 'PRIVATE',
}

export {
  AUTHORITY,
  STATUS,
  BRANCH_STATUS_KEY,
  AUTHORITY_KEY,
  getRoleOptions,
  CALCULATION_BASIS,
}
